import { normalizeApiId } from './connections/connector';

/** Normalize connector aliases for catalog identity; leave the runtime operation ID unchanged. */
export const getOperationKey = (operationId: string, connectorId?: string): string =>
  JSON.stringify([normalizeApiId(connectorId ?? ''), operationId]);
